module.exports = __webpack_public_path__ + "img/option.383d1a1d.png";